import * as React from "react";

import Helmet from "react-helmet";

import { constants } from "@common/_constants";

//Should we use meta-keywords
// https://www.firstscribe.com/shouldnt-we-be-using-meta-keywords-internet-marketing-mysteries/

//Must-have social media meta tags
// https://moz.com/blog/meta-data-templates-123

// TODO: move this to services
const getMetaTags = (title, description, keywords) => {
    const img = constants.Routing.Mvc.LOGO_OG;
    const url = window.location.href;

    const metaTags = [
        { name: "description", content: description },
        { name: "accept-language", content: "en-US" },
        //Google+
        { itemprop: "name", content: title },
        { itemprop: "description", content: description },
        { itemprop: "image", content: img },
        //?
        { name: "application-name", content: "Relode" },
        //Apple/Safari
        { name: "apple-mobile-web-app-capable", content: "yes" },
        { name: "apple-mobile-web-app-title", content: "Relode" },
        { name: "apple-mobile-web-app-status-bar-style", content: "black" },
        //Facebook
        { name: "og:title", content: title },
        { name: "og:type", content: "webiste" },
        { name: "og:url", content: url },
        { name: "og:description", content: description },
        { name: "og:image", content: img },
        //Pinterest
        {
            name: "p:domain_verify",
            content: constants.GlobalConfig.pinterestDomainId
        }
    ];

    if (keywords) metaTags.push({ name: "keywords", content: keywords });

    return metaTags;
};

interface SeoTagsProps {
    title: string
    description: string
    keywords: string
};


export const SeoTags = (props: SeoTagsProps) => {
    return (
        <Helmet
            htmlAttributes={{ lang: "en", dir: "ltr" }}
            title={`${props.title} | relode`}
            meta={getMetaTags(props.title, props.description, props.keywords)}
        />
    );
};

export default SeoTags;

// TODO: move this to services
export const SeoHelper = {
    getJobSearchTitle: (location, category) => {
        return GetJobSearchKeyPhrase(location, category);
    },
    getJobSearchKeywords: (defaultKeywords, location, category) => {
        if (defaultKeywords) defaultKeywords = "," + defaultKeywords;
        const keyphrase = GetJobSearchKeyPhrase(location, category);
        return `${keyphrase}${defaultKeywords}`;
    },
    getJobSearchDescription: (defaultDesc, location, category) => {
        const keyphrase = GetJobSearchKeyPhrase(location, category);
        return `${keyphrase} by Relode. ${defaultDesc}`;
    },

    getJobDetailsTitle: (location, title) => {
        return GetJobDetailKeyPhrase(location, title);
    },
    getJobDetailsKeywords: (defaultKeywords, location, title) => {
        if (defaultKeywords) defaultKeywords = "," + defaultKeywords;
        const keyphrase = GetJobDetailKeyPhrase(location, title);
        return `${keyphrase}${defaultKeywords}`;
    },
    getJobDetailsDescription: (defaultDesc, location, title) => {
        const keyphrase = GetJobDetailKeyPhrase(location, title);
        return `${keyphrase} by Relode. ${defaultDesc}`;
    },

    getJobRoute(job) {
        const route = `/${job.job_id}/${SeoHelper.sani(job.primary_job_category_name)}/${SeoHelper.sani(
            job.location
        )}/${SeoHelper.sani(job.job_name)}`;
        return route;
    },
    sani: text => {
        if (!text) return "";
        return text
            .replace(/%20/g, " ") //keep spaces
            .replace(/ /g, "-")
            .replace(/,/g, "")
            .replace(/\//g, "%2F") //encode '/'
            .replace(/&/g, "%26")  //encode '&'
            .replace(/%/g, "%25"); //encode '%'

    }
};

const GetJobSearchKeyPhrase = (location, category) => {
    if (!category || category === constants.Defaults.JobPosition.AllJobPositions.JOB_POSITION_NAME) {
        category = constants.Defaults.Search.SEO_DEFAULT_JOB_CATEGORY;
    }

    if (!!location) {
        location = location.replace(", ", " ");
        return `${category} jobs in ${location}`;
    } else {
        return `${category} jobs`;
    }
};

const GetJobDetailKeyPhrase = (location, title, isDetail = false) => {
    if (!!location) {
        location = location.replace(", ", " ");
        return `${title} job in ${location}`;
    } else {
        return `${title} job`;
    }
};
